import _capitalize from "lodash/capitalize";
import { BulbIcon, CheckmarkIcon, CodeIcon, CrossCircleIcon, CrossCircleInvertedIcon } from '@datacamp/waffles-icons';
import { colors } from '@datacamp/waffles-tokens';
import cx from 'classnames';
import React from 'react';
import { appendClassSuffix } from './utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
var TabIconByMessageType = {
  ASSISTANT: ___EmotionJSX(CrossCircleInvertedIcon, {
    "aria-hidden": true,
    color: "#FF5400"
  }),
  CORRECT: ___EmotionJSX(CheckmarkIcon, {
    "aria-hidden": true,
    color: colors.green
  }),
  HINT: ___EmotionJSX(BulbIcon, {
    "aria-hidden": true,
    color: colors.navy
  }),
  INCORRECT: ___EmotionJSX(CrossCircleIcon, {
    "aria-hidden": true,
    color: colors.orange
  }),
  SOLUTION: ___EmotionJSX(CodeIcon, {
    "aria-hidden": true,
    color: colors.navy
  })
};
export var getTabIcon = function getTabIcon(feedbackMessageType) {
  return TabIconByMessageType[feedbackMessageType];
};
var Tab = function Tab(_ref) {
  var feedbackMessage = _ref.feedbackMessage,
    onClick = _ref.onClick;
  return ___EmotionJSX("li", {
    className: "dc-sct-feedback__tab-container"
  }, ___EmotionJSX("button", {
    "aria-label": _capitalize(feedbackMessage.messageType),
    className: cx('dc-sct-feedback__tab', appendClassSuffix('dc-sct-feedback__tab', feedbackMessage.messageType), {
      'dc-sct-feedback__tab--active': feedbackMessage.isActive
    }),
    onClick: onClick
  }, getTabIcon(feedbackMessage.messageType)));
};
var Tabs = function Tabs(_ref2) {
  var feedbackMessages = _ref2.feedbackMessages,
    onClickTab = _ref2.onClickTab;
  return ___EmotionJSX("ul", {
    className: "dc-sct-feedback__tab-list"
  }, feedbackMessages.map(function (feedbackMessage) {
    return ___EmotionJSX(Tab, {
      feedbackMessage: feedbackMessage,
      key: feedbackMessage.messageType + feedbackMessage.tabIndex.toString(),
      onClick: function onClick() {
        return onClickTab(feedbackMessage.tabIndex);
      }
    });
  }));
};
export default Tabs;